import React from "react";
import MasterComponent from "../../../../components/Forms";
import { MasterConfigs } from "../../../../interfaces/entity";

const BusinessUnit = () => {
    const config: MasterConfigs = {
        api: () => '/business-unit',
        title: 'Business Unit',
        modalTitle: () => config.title,
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Code',
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: '50%',
                ellipsis: true
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
        ],
        actions: [{ actionType: 'Add', name: 'Add' }]
    }

    return <MasterComponent config={config} />
}

export default BusinessUnit;